<template>
    <div class="form-group">
        <label>Synlighet</label>

        <select name="visibility" class="form-control" v-model="selectedVisibilityModel">
            <option value="">Välj</option>
            <option value="3">Synligt för alla</option>
            <option value="2">Synligt för medlemmar</option>
            <option value="1">Synligt för dina vänner</option>
            <option value="0">Dolt för alla</option>
        </select>

        <p class="help-block" v-if="combinedVisibility === 0">
            Detta inlägget kommer bara att vara synligt för dig.
            <span v-if="selectedVisibility > blogVisibility"
                >(Eftersom hela din blogg bara är synlig för dig)</span
            >
        </p>
        <p class="help-block" v-if="combinedVisibility === 1">
            Detta inlägget kommer bara att vara synligt för dina vänner.
            <span v-if="selectedVisibility > blogVisibility"
                >(Eftersom hela din blogg bara är synlig för dina vänner)</span
            >
        </p>
        <p class="help-block" v-if="combinedVisibility === 2">
            Detta inlägget kommer bara att vara synligt för medlemmar.
            <span v-if="selectedVisibility > blogVisibility"
                >(Eftersom hela din blogg bara är synlig för medlemmar)</span
            >
        </p>
        <p class="help-block" v-if="combinedVisibility === 3">
            Detta inlägget kommer att vara synligt för alla.
        </p>
    </div>
</template>

<script>
export default {
    props: {
        oldVisibility: Number,
        blogVisibility: Number
    },

    mounted() {
        if (this.oldVisibility !== undefined) {
            this.selectedVisibilityModel = this.oldVisibility;
        }
    },

    data() {
        return {
            selectedVisibilityModel: this.blogVisibility,
            visibilityStrings: {
                0: 'ingen',
                1: 'vänner',
                2: 'medlemmar',
                3: 'alla'
            }
        };
    },

    computed: {
        selectedVisibility: function () {
            return parseInt(this.selectedVisibilityModel);
        },

        combinedVisibility: function () {
            return Math.min(this.selectedVisibility, this.blogVisibility);
        }
    },

    methods: {
        //
    }
};
</script>
